import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "IsoOutline"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 4.5H21C21.8284 4.5 22.5 5.17157 22.5 6V18C22.5 18.8284 21.8284 19.5 21 19.5H3C2.17157 19.5 1.5 18.8284 1.5 18V6C1.5 5.17157 2.17157 4.5 3 4.5ZM3 6V18H21V6H3ZM18 15.75H15.75C14.9216 15.75 14.25 15.0784 14.25 14.25V9.75C14.25 8.92157 14.9216 8.25 15.75 8.25H18C18.8284 8.25 19.5 8.92157 19.5 9.75V14.25C19.5 15.0784 18.8284 15.75 18 15.75ZM15.75 14.25V9.75H18V14.25H15.75ZM11.25 15.75H7.5V14.25H11.25V12.75H9C8.17157 12.75 7.5 12.0784 7.5 11.25V9.75C7.5 8.92157 8.17157 8.25 9 8.25H12.75V9.75H9V11.25H11.25C12.0784 11.25 12.75 11.9216 12.75 12.75V14.25C12.75 15.0784 12.0784 15.75 11.25 15.75ZM6 8.25H4.5V15.75H6V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/IsoOutline.vue"]]);
